import React, { useCallback } from "react";

import { Input } from "@treelab/panda";

import { formatMessage } from "../../../../../../lib/intl";
import { getCookie } from "../../../../../../lib/cookies";

import { IFilterValue, DateComparisonOptions } from "../../../../../../types/form-type";
import { DateFormat, TimeFormat } from "../../../../../../types/table-type";

import {
  DATE_COMPARISON_OPTIONS,
  SHOW_DATE_COMPARISON_INPUT,
  SHOW_DATE_DATE_INPUT,
  SHOW_DATE_NUMBER_INPUT,
} from "../../../../../../utils/filter_secondary";

import { Container, Item } from "./styled";

const locale = getCookie("locale");

const getComparisonOptions = () => {
  return DATE_COMPARISON_OPTIONS.map(({ name: name_, value: value_ }) => ({
    value: value_,
    name: formatMessage({ id: name_ }),
  }));
};

interface IProps {
  name: string;
  value: IFilterValue;
  onChange: (value: { [key: string]: any }) => void;
}

const DateComparison: React.FC<IProps> = ({ name, value, onChange }) => {
  const handleDateNumberChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const data = e.target.value;
      onChange({ filterString: data });
    },
    [onChange]
  );

  const handleComparisonOptionChange = useCallback(
    (data: DateComparisonOptions) => {
      onChange({ dateComparisonOptions: data });
    },
    [onChange]
  );

  const handleDateDateChange = useCallback(
    (date: Date) => {
      const value = date.toISOString();
      onChange({ filterString: value });
    },
    [onChange]
  );

  const showDateComparison = SHOW_DATE_COMPARISON_INPUT[value.filterCondition];
  const showDateNumberInput = value.dateComparisonOptions && SHOW_DATE_NUMBER_INPUT[value.dateComparisonOptions];
  const showDateDateInput = value.dateComparisonOptions && SHOW_DATE_DATE_INPUT[value.dateComparisonOptions];

  if (!showDateComparison) return null;

  return (
    <Container childrenCount={showDateNumberInput || showDateDateInput ? 2 : 1}>
      {showDateNumberInput && (
        <Item>
          <Input.Text
            input={{
              name: `filterString`,
              onChange: handleDateNumberChange,
              value: value.filterString,
            }}
            inputType="number"
            meta={{}}
            placeholder="#"
          />
        </Item>
      )}
      <Item>
        <Input.Select
          input={{
            name: `dateComparisonOptions`,
            onChange: handleComparisonOptionChange,
            value: value.dateComparisonOptions,
          }}
          options={getComparisonOptions()}
          meta={{}}
        />
      </Item>
      {showDateDateInput && (
        <Item>
          <Input.DateTime
            input={{
              name: `filterString`,
              onChange: handleDateDateChange,
              value: value.filterString,
            }}
            dateFormatOptions={{
              dateFormat: DateFormat.ISO,
              timeFormat: TimeFormat.TWELVE_HOUR,
              includeTime: false,
            }}
            placeholder="YYYY-MM-DD"
            locale={locale}
            meta={{}}
          />
        </Item>
      )}
    </Container>
  );
};

export default DateComparison;
